<template>
    <b-modal v-if="visibility" v-model="opened" title="Отображение на доске и в плане" hide-footer
        :no-close-on-backdrop="pending" :no-close-on-esc="pending" :hide-header-close="pending">
        <p class="text-muted">Настройка действует для всех дат. Она не меняет назначения и права доступа.</p>
        <b-form @submit.prevent="save">
            <b-row>
                <b-col v-for="view in views" :key="view.key" cols="12" md="6">
                    <b-form-group :label="view.label" :label-for="`visibility-${view.key}`">
                        <b-form-select :id="`visibility-${view.key}`" v-model="form[view.key]" :options="options"
                            :disabled="!canManage || pending" />
                        <div class="text-muted mt-2">{{ reason(visibility[view.key]) }}</div>
                    </b-form-group>
                </b-col>
            </b-row>
            <p class="text-muted">«Показывать» отменяет скрытие по отделу. Остальные условия списка и фильтры экрана сохраняются.</p>
            <b-alert :show="Boolean(error)" variant="danger">{{ error }}</b-alert>
            <div class="d-flex flex-wrap justify-content-end">
                <b-button v-if="canManage" type="submit" variant="primary" size="sm" :disabled="pending || !dirty">
                    {{ pending ? 'Сохранение…' : 'Сохранить отображение' }}
                </b-button>
                <b-button class="ml-2" size="sm" variant="outline-secondary" :disabled="pending" @click="opened = false">Закрыть</b-button>
                <b-button v-if="conflict" class="ml-2" size="sm" variant="outline-secondary" :disabled="pending" @click="refresh">
                    Перечитать состояние
                </b-button>
            </div>
        </b-form>
    </b-modal>
</template>

<script>
import api from '@/utils/api';
export default {
    name: 'EmployeeWorkforceVisibility',
    props: {employee: {type: Object, required: true}},
    data() {
        return {opened: false, form: {board: 'inherit', plan: 'inherit'}, original: null, pending: false, error: '', conflict: false, sequence: 0,
            views: [{key: 'board', label: 'Доска'}, {key: 'plan', label: 'План'}],
            options: [{value: 'inherit', text: 'По общим настройкам'}, {value: 'show', text: 'Показывать'}, {value: 'hide', text: 'Скрывать'}]};
    },
    computed: {
        visibility() { return this.employee.workforce_visibility || null; },
        canManage() { return Boolean(this.employee.permissions && this.employee.permissions.can_manage_employee); },
        dirty() { return this.original && this.views.some(view => this.form[view.key] !== this.original[view.key].mode); }
    },
    watch: {
        'employee.employee_id'() { this.sequence++; this.pending = false; this.opened = false; this.reset(); },
        visibility: {immediate: true, handler() { if (!this.dirty && !this.pending) this.reset(); }}
    },
    methods: {
        open() { if (!this.dirty) this.reset(); this.opened = true; },
        reset() {
            this.original = this.visibility;
            this.form = {board: this.visibility && this.visibility.board.mode || 'inherit', plan: this.visibility && this.visibility.plan.mode || 'inherit'};
            this.error = ''; this.conflict = false;
        },
        reason(value) {
            if (!value) return '';
            return {individual_hide: 'Скрыт по индивидуальной настройке', individual_show: 'Показывается по индивидуальной настройке',
                department: 'Скрыт по настройке отдела', general: 'Не скрыт общими настройками'}[value.reason] || '';
        },
        refresh() { this.reset(); this.$emit('saved'); },
        async save() {
            if (!this.canManage || !this.dirty || this.pending) return;
            const sequence = ++this.sequence;
            this.pending = true; this.error = ''; this.conflict = false;
            try {
                await api.patch(`/api/employees/${this.employee.employee_id}/workforce-visibility`, {
                    ...this.form, expected_revision: this.original.revision
                }, {ignoreModal: true});
                if (sequence !== this.sequence) return;
                this.original = null; this.opened = false; this.$emit('saved');
            } catch (error) {
                if (sequence !== this.sequence) return;
                const data = error.response && error.response.data;
                this.error = data && (data.msg || data.message) || 'Не удалось сохранить отображение сотрудника';
                this.conflict = Boolean(error.response && error.response.status === 409);
            } finally { if (sequence === this.sequence) this.pending = false; }
        }
    }
};
</script>
